import React from "react";
import styles from "./NoDataView.module.scss";
import Column from "../Column";

interface NoDataProps extends React.HTMLProps<HTMLDivElement> { }


const NoDataView: React.FC<NoDataProps> = (props) =>{
  return (
    <Column
      className='m-2'
      style={{
        alignContent:'center',
        justifyContent:'center',
        // height: "100%",
        ...props.style
      }}>
      <div className={styles.noDataView}>
        <div className={styles.icon}>
          {/* Example SVG for an empty folder */}
          <svg viewBox='0 0 64 64'>
            <path d='M32 12l-6-6H8c-2.2 0-4 1.8-4 4v40c0 2.2 1.8 4 4 4h48c2.2 0 4-1.8 4-4V20c0-2.2-1.8-4-4-4H32zM8 48V20h48v28H8z' />
          </svg>
        </div>
        <div className={styles.message}>No Data Available</div>
        <div className={styles.messageDetail}>There is no data to show you right now.</div>
      </div>
    </Column>
  );
};

export default NoDataView;
